<template>
  <v-select
    :items="items"
    item-text="name"
    item-value="id"
    :label="$t('fields.subject')"
    :error-messages="errors"
    @input="changed"
    :clearable="clearable"
    :multiple="multiple"
    :disabled="disabled"
    v-model="selected"
  >
    <template v-slot:append-item>
      <div v-intersect="endIntersect" />
    </template>
  </v-select>
</template>
<script>

import { schoolsService } from '../../../utils/services/schools.service';

export default {
  name: 'SchoolSubjectSelect',
  props: {
    errors: {
      type: [String, Array],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    schoolId: {
      type: Number,
      default: 0,
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
  },
  data() {
    return {
      selected: this.value,
      items: [],
      paginations: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  methods: {
    changed(event) {
      this.$emit('input', event);
    },

    async endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        if (this.paginations.current_page + 1 <= this.paginations.last_page) {
          const more = await this.fetch(this.paginations.current_page + 1);
          this.items = [...this.items, ...more];
        }
      }
    },

    async fetch(page) {
      return schoolsService.subjects(this.schoolId, {
          page: page || 1,
          itemsPerPage: 1000,
          filters: {
            sortBy: ['name'],
            sortDesc: [false],
          },
        })
      .then(response => {
        const { current_page, last_page } = response.data.meta;
        this.paginations.current_page = current_page;
        this.paginations.last_page = last_page;
        return response.data.data;
      })
      .catch(error => {
          this.handleError(error, this.errors);
          return [];
      });
    },
  },
  async created() {
    this.items = await this.fetch(1);
  },
};
</script>
